module.exports = __webpack_public_path__ + "img/0Q3A3733_L_WoodMatted_MockedUp.2f5aada1.jpg";